import renderMap from "../actions/renderMap";

const PageMap = ($) => {
	if ($("body").hasClass("page-template-map")) {
		renderMap($);
	}
};

export default PageMap;
